export default __webpack_public_path__ + "static/media/default-item.1711eb2f.png";